module.exports = __webpack_public_path__ + "static/media/skillsChecker.85236cfc.png";